import {
  en_nubankProvidedTranslations,
  pt_nubankProvidedTranslations,
} from "@hopper-b2b/i18n";
import { TranslationLanguage } from "@hopper-b2b/types";
import { merge } from "lodash-es";
import pt_terms from "../components/TermsAndConditionsWrapper/pt-terms.json";

export const providedTranslations = {
  [TranslationLanguage.pt]: merge(pt_nubankProvidedTranslations, pt_terms),
  [TranslationLanguage.en]: merge(en_nubankProvidedTranslations, pt_terms),
};
